import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useMessageUnread } from '../context/MessageUnreadContext';
import { HeaderEmojiButton } from './layout/NavMenu';

const MessageInboxButton: React.FC = () => {
  const navigate = useNavigate();
  const { unreadCount, otherLocationUnreadCount, otherLocations } = useMessageUnread();

  const otherLabel = otherLocations.length > 0
    ? otherLocations.map((l) => `${l.unreadCount} at ${l.locationName ?? 'another location'}`).join(', ')
    : `${otherLocationUnreadCount} at other locations`;

  const title = otherLocationUnreadCount > 0
    ? `Messages${unreadCount > 0 ? ` (${unreadCount} unread here)` : ''} — ${otherLabel}`
    : 'Messages';

  return (
    <HeaderEmojiButton
      emoji="💬"
      label={title}
      unreadCount={unreadCount}
      secondaryUnreadCount={otherLocationUnreadCount > 0 ? otherLocationUnreadCount : undefined}
      onClick={() => navigate('/messages')}
    />
  );
};

export default MessageInboxButton;
